export default {
  appName: 'Lizenzverwaltung',
  apiUrl: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  apiRequestTimeout: 5000,
  defaultLicenseVersion: 4,
  volume: '4.0'
};
